import React, { useMemo } from 'react';

import { SearchFilterContent } from 'components/search/SearchFilterContent';
import { TruckFilterContent } from 'components/search/TruckFilterContent';
import { VehicleSearchFilters } from 'components/search/VehicleSearchFilters';

const withSearchFilterContent = (WrappedComponent) => {
	const WithSearchFilterContent = (props) => {
		const {
			isTruckSerp,
			isVehicleSerp,
			handleShowUnitGuide,
			priceTransparency,
			cityUrl,
			pageType,
			facetCounts,
			useNewSearch,
			...rest
		} = props;

		const { filterComponent, listType } = useMemo(() => {
			let fc = (
				<SearchFilterContent
					onShowUnitGuide={handleShowUnitGuide}
					priceTransparency={priceTransparency}
					cityUrl={cityUrl}
					pageType={pageType}
					facetCounts={facetCounts}
				/>
			);

			if (isTruckSerp) {
				fc = <TruckFilterContent />;
			} else if (isVehicleSerp) {
				fc = (
					<VehicleSearchFilters
						useNewSearch={useNewSearch}
						facetCounts={facetCounts}
					/>
				);
			}

			return {
				filterComponent: fc,
				listType: isTruckSerp ? 'grid' : 'column',
			};
		}, [
			isTruckSerp,
			isVehicleSerp,
			facetCounts,
			handleShowUnitGuide,
			priceTransparency,
			cityUrl,
			pageType,
			useNewSearch,
		]);

		return (
			<WrappedComponent
				{...rest}
				isTruckSerp={isTruckSerp}
				isVehicleSerp={isVehicleSerp}
				handleShowUnitGuide={handleShowUnitGuide}
				priceTransparency={priceTransparency}
				cityUrl={cityUrl}
				pageType={pageType}
				facetCounts={facetCounts}
				useNewSearch={useNewSearch}
				filterComponent={filterComponent}
				listType={listType}
			/>
		);
	};

	return WithSearchFilterContent;
};

export default withSearchFilterContent;
